import { Link as ScrollLink } from 'react-scroll'

import { useTranslations } from 'next-intl'

import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import GrowthIndicator from '~/components/atoms/GrowthIndicator/GrowthIndicator'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'
import { Growth } from '~/enums/growth'
import { numberWithCommas } from '~/utils/formatCurrency'

import styles from './MAB100Header.module.css'

export interface MAB100HeaderProps {
  title: string
  subtitle?: string
  testID?: string
  moduleId?: string
  total?: number
  change?: string | number
  pageBlocks: any
}

const MAB100Lines = () => {
  return (
    <div className={styles.linesBackground}>
      <div className={styles.linesBackgroundLines}>
        <svg
          viewBox="0 0 2286 353"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M-4 99.511C118.5 99.511 98.1545 5.27191 139 3.49975C240.427 -0.900823 264.081 161.899 364.5 158C479.748 153.525 468.966 78.7073 587.378 60.3144C606.37 57.3644 628.854 57.4178 648.761 55.1414C671.414 52.551 693.092 19.5732 719 19.5C730.135 19.4685 768.72 68.8641 793 72.4927C837.973 79.214 918.249 33.8203 962.5 41C984.836 44.624 1010.61 81.1286 1035.54 82.1406C1096.76 84.6264 1159.18 84.3036 1220.73 82.8075C1257.67 81.9099 1346.25 176.092 1359.5 174C1398.38 167.864 1450.68 48.5084 1489.58 42.3896C1521.55 37.3615 1547.93 28.7081 1581.95 25.2627C1593.37 24.1065 1606.71 26.9808 1615.08 29.6815C1638.16 37.1264 1657.56 45.7694 1673.67 54.8484C1717.89 79.7779 1732.02 102.195 1800.92 123.338C1817.09 128.3 1830.48 136.383 1853 136.981C1870.01 137.432 1878.75 129.857 1889.5 125.687C1915.52 115.593 1935.1 103.884 1963 94.3003C1996.09 82.9337 2036.54 73.903 2071.61 63.1377C2106.7 52.3636 2089.81 88.8414 2130 79.9999C2168 66.9999 2156 120.5 2202.5 127.5C2244 128.5 2276.5 98.1479 2287 99.4999"
            stroke="#4DC3F8"
            strokeWidth="6"
          />
          <path
            d="M-4 305.814C12.1316 300.639 92.6545 257.435 133.5 255.648C234.927 251.211 237.581 292.904 338 288.972C453.248 284.46 439.21 333.677 521.5 342C585.953 348.519 586 268.314 648.761 261.078C671.414 258.466 695.754 261.26 721.663 261.186C732.798 261.154 811.663 251.99 835.943 255.648C880.916 262.425 890.258 306.096 934.508 313.335C956.844 316.989 1002.07 182.98 1027 184C1088.23 186.506 1159.18 290.481 1220.73 288.972C1257.67 288.067 1351.44 215.658 1364.7 213.549C1403.57 207.363 1450.68 254.39 1489.58 248.22C1521.55 243.151 1547.93 234.426 1581.95 230.952C1593.37 229.786 1606.71 232.684 1615.08 235.407C1638.16 242.914 1631.89 283.121 1647.99 292.275C1692.22 317.41 1732.02 308.52 1800.92 329.837C1817.09 334.841 1826.33 331.788 1848.85 332.39C1865.86 332.845 1922.04 353.643 1932.78 349.439C1958.8 339.262 2025.1 280.163 2053 270.5C2086.09 259.039 2248.93 316.854 2284 306"
            stroke="#6068D6"
            strokeWidth="6"
          />
          <path
            d="M-4 180.511C12.1314 175.379 87.2712 148.459 128.116 146.687C229.541 142.286 282.485 195.352 382.903 191.452C498.15 186.977 468.96 159.707 587.37 141.314C606.361 138.365 628.845 138.418 648.752 136.142C671.404 133.551 700.241 116.429 726.149 116.356C737.284 116.324 811.652 127.128 835.931 130.757C880.904 137.478 905.234 168.358 949.484 175.538C971.819 179.162 1010.59 162.129 1035.52 163.141C1096.75 165.626 1157.73 199.911 1219.28 198.415C1256.22 197.517 1356.48 141.73 1369.73 139.638C1408.61 133.502 1445.69 150.325 1484.59 144.206C1516.56 139.178 1547.91 109.708 1581.93 106.263C1593.35 105.107 1606.69 107.981 1615.06 110.682C1638.14 118.127 1657.54 126.77 1673.65 135.849C1717.87 160.778 1646.52 180.754 1715.42 201.896C1731.59 206.859 1830.46 217.383 1852.97 217.981C1869.99 218.432 1878.73 210.857 1889.47 206.687C1915.49 196.593 1935.07 184.884 1962.97 175.3C1996.06 163.934 2029.59 191.276 2064.66 180.511C2099.76 169.737 2247.31 188.342 2287.5 179.5"
            stroke="#CA6BDA"
            strokeWidth="6"
          />
        </svg>
        <svg
          viewBox="0 0 2286 353"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M-4 99.511C118.5 99.511 98.1545 5.27191 139 3.49975C240.427 -0.900823 264.081 161.899 364.5 158C479.748 153.525 468.966 78.7073 587.378 60.3144C606.37 57.3644 628.854 57.4178 648.761 55.1414C671.414 52.551 693.092 19.5732 719 19.5C730.135 19.4685 768.72 68.8641 793 72.4927C837.973 79.214 918.249 33.8203 962.5 41C984.836 44.624 1010.61 81.1286 1035.54 82.1406C1096.76 84.6264 1159.18 84.3036 1220.73 82.8075C1257.67 81.9099 1346.25 176.092 1359.5 174C1398.38 167.864 1450.68 48.5084 1489.58 42.3896C1521.55 37.3615 1547.93 28.7081 1581.95 25.2627C1593.37 24.1065 1606.71 26.9808 1615.08 29.6815C1638.16 37.1264 1657.56 45.7694 1673.67 54.8484C1717.89 79.7779 1732.02 102.195 1800.92 123.338C1817.09 128.3 1830.48 136.383 1853 136.981C1870.01 137.432 1878.75 129.857 1889.5 125.687C1915.52 115.593 1935.1 103.884 1963 94.3003C1996.09 82.9337 2036.54 73.903 2071.61 63.1377C2106.7 52.3636 2089.81 88.8414 2130 79.9999C2168 66.9999 2156 120.5 2202.5 127.5C2244 128.5 2276.5 98.1479 2287 99.4999"
            stroke="#4DC3F8"
            strokeWidth="6"
          />
          <path
            d="M-4 305.814C12.1316 300.639 92.6545 257.435 133.5 255.648C234.927 251.211 237.581 292.904 338 288.972C453.248 284.46 439.21 333.677 521.5 342C585.953 348.519 586 268.314 648.761 261.078C671.414 258.466 695.754 261.26 721.663 261.186C732.798 261.154 811.663 251.99 835.943 255.648C880.916 262.425 890.258 306.096 934.508 313.335C956.844 316.989 1002.07 182.98 1027 184C1088.23 186.506 1159.18 290.481 1220.73 288.972C1257.67 288.067 1351.44 215.658 1364.7 213.549C1403.57 207.363 1450.68 254.39 1489.58 248.22C1521.55 243.151 1547.93 234.426 1581.95 230.952C1593.37 229.786 1606.71 232.684 1615.08 235.407C1638.16 242.914 1631.89 283.121 1647.99 292.275C1692.22 317.41 1732.02 308.52 1800.92 329.837C1817.09 334.841 1826.33 331.788 1848.85 332.39C1865.86 332.845 1922.04 353.643 1932.78 349.439C1958.8 339.262 2025.1 280.163 2053 270.5C2086.09 259.039 2248.93 316.854 2284 306"
            stroke="#6068D6"
            strokeWidth="6"
          />
          <path
            d="M-4 180.511C12.1314 175.379 87.2712 148.459 128.116 146.687C229.541 142.286 282.485 195.352 382.903 191.452C498.15 186.977 468.96 159.707 587.37 141.314C606.361 138.365 628.845 138.418 648.752 136.142C671.404 133.551 700.241 116.429 726.149 116.356C737.284 116.324 811.652 127.128 835.931 130.757C880.904 137.478 905.234 168.358 949.484 175.538C971.819 179.162 1010.59 162.129 1035.52 163.141C1096.75 165.626 1157.73 199.911 1219.28 198.415C1256.22 197.517 1356.48 141.73 1369.73 139.638C1408.61 133.502 1445.69 150.325 1484.59 144.206C1516.56 139.178 1547.91 109.708 1581.93 106.263C1593.35 105.107 1606.69 107.981 1615.06 110.682C1638.14 118.127 1657.54 126.77 1673.65 135.849C1717.87 160.778 1646.52 180.754 1715.42 201.896C1731.59 206.859 1830.46 217.383 1852.97 217.981C1869.99 218.432 1878.73 210.857 1889.47 206.687C1915.49 196.593 1935.07 184.884 1962.97 175.3C1996.06 163.934 2029.59 191.276 2064.66 180.511C2099.76 169.737 2247.31 188.342 2287.5 179.5"
            stroke="#CA6BDA"
            strokeWidth="6"
          />
        </svg>
      </div>
    </div>
  )
}

export default function MAB100Header({
  title,
  subtitle,
  moduleId,
  total = 0,
  change,
  testID,
  pageBlocks,
}: MAB100HeaderProps) {
  const t = useTranslations('mab100.header')
  const defaultSubtitle = subtitle || t('subtitle')
  const totalPrice = total ? `${numberWithCommas(total)}` : ''

  let growthItem = Growth.static
  if (Number(change) > 0) growthItem = Growth.increase
  if (Number(change) < 0) growthItem = Growth.decrease

  const pageBlockModuleIds = pageBlocks.map((block: any) => block.moduleId)

  return (
    <Fixture
      id={moduleId}
      theme={ComponentTheme.primary}
      verticalPadding={false}
      noPaddingBottom
      className={styles.base}
      data-testid={testID}
    >
      <MAB100Lines />

      <Container gutters={gutterTypes.always} cssClass={styles.container}>
        <div className={styles.head}>
          <Text
            Tag="h1"
            size={TextSizes.secondaryTitleXLrg}
            className={styles.title}
            dataNoSnippet={true}
          >
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </Text>
          <Text
            Tag="h3"
            size={TextSizes.primaryTitleMed}
            className={styles.secondaryTitle}
          >
            <span dangerouslySetInnerHTML={{ __html: defaultSubtitle }} />
          </Text>
        </div>
        <div className={styles.statsContainer}>
          <div className={styles.stats}>
            <Text
              Tag="h4"
              size={TextSizes.primaryTitleLrg}
              className={styles.statsPrice}
              dataNoSnippet={true}
            >
              {totalPrice}
              <em>PTS</em>
            </Text>
            <div className={styles.statsGrowth}>
              <GrowthIndicator size="mediumLarge" type={growthItem} />
              <Text
                size={TextSizes.primaryTitleMed}
                className={styles.statsGrowthText}
                dataNoSnippet={true}
              >
                {change ? `${change}%` : '...'}
              </Text>
            </div>
          </div>
          <Text size={TextSizes.bodySml} className={styles.statsTitle}>
            <span dangerouslySetInnerHTML={{ __html: t('description') }} />
          </Text>
          {pageBlockModuleIds.includes('faqs') && (
            <ScrollLink to={`faqs`} href={`#faqs`} smooth={true}>
              <Button
                variant={ButtonVariants.textLinkSmallUnderline}
                className={styles.scrollToButton}
              >
                {t('howItWorks')}
              </Button>
            </ScrollLink>
          )}
        </div>
      </Container>
    </Fixture>
  )
}
